import { create } from "zustand";

/// The one consent dialog outside the blocking gate. `reason` is a refused
/// door's sentence (`terms_not_accepted`); without one it is a plain review.
interface TermsPromptStore {
  open: boolean;
  reason?: string;
  ask: (reason?: string) => void;
  close: () => void;
}

export const useTermsPromptStore = create<TermsPromptStore>((set) => ({
  open: false,
  ask: (reason) => set({ open: true, reason }),
  close: () => set({ open: false, reason: undefined }),
}));
